import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes } from "@ryde/layout";

import { PassengersPageContent } from "./passengers.page.content";

export const PassengersPage: FC = () => {
  return (
    <PageContextWrapper entity="passenger">
      <PassengersPageContent />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
